import { IconEye, IconEyeOff } from "@tabler/icons-react";
import React, { useState } from "react";
import { UseFormRegister, FieldError, RegisterOptions } from "react-hook-form";

interface InputProps {
  name: string;
  type?: string;
  title?: string;
  placeholder?: string;
  register?: UseFormRegister<any>; // You can replace `any` with your form type
  validation?: RegisterOptions;
  error?: FieldError | any;
  other?: any;
  className?: string;
  labelClass?: string;
  disabled?: boolean;
  defaultValue?: string;
  value?: string;
  removeDiv?: boolean;
  step?: any;
  inputMode?: any;
  inputClassName?: any;
  pattern?: string;
  min?: string;
}

const Input: React.FC<InputProps> = ({
  name,
  title,
  type,
  placeholder = "",
  register,
  validation,
  error,
  other,
  className = "",
  labelClass = "",
  removeDiv = false,
  disabled = false,
  defaultValue = "",
  value,
  step,
  inputMode,
  inputClassName,
  pattern,
  min
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputField = (
    <input
      type={type === "password" && showPassword ? "text" : type}
      pattern={pattern} 
      min={min}
      placeholder={placeholder}
      className={
        inputClassName
          ? inputClassName
          : `w-full rounded-full py-[6px] px-4  outline-none bg-white border border-[#D8D8D8] text-[#1E1E1E] ${type === "number" ? "hide-spinner" : ""
          }`
      }
      {...(value !== undefined ? { value } : { defaultValue })} // only pass one
      {...(register ? register(name, validation) : {})}
      {...other}
      disabled={disabled}
      {...(step !== undefined ? { step } : {})}
      {...(inputMode !== undefined ? { inputMode } : {})}
      autoComplete="off"
      onKeyDown={(e) => {
        if (type === "number" && ["e", "E", "+", "-"].includes(e.key)) {
          e.preventDefault();
        }
      }}
    />
  );

  return (
    <div className={`space-y-1 ${className}`}>
      {title && (
        <label
          className={labelClass ? labelClass : 'text-[#1E293B]  text-sm whitespace-nowrap'}
        >
          {title}
          {validation?.required && <span className="text-red-600 ml-1">*</span>}
        </label>
      )}
      <div className="w-full">
        {!removeDiv ? (
          <div className="relative">
            {inputField}
            {type === "password" && (
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/4 text-gray-500"
              >
                {showPassword ? (
                  <IconEyeOff size={18} />
                ) : (
                  <IconEye size={18} />
                )}
              </button>
            )}
          </div>
        ) : (
          inputField
        )}
      </div>
        {(error && name !== 'receiver.mobile' && name !== 'sender.mobile') &&
          (error?.message?.includes("\n") ? (
            error?.message?.split("\n").map((line: string, index: number) => (
              <span
                key={`val${index + 1}`}
                className="text-red-500 text-xs block font-light"
              >
                {line}
              </span>
            ))
          ) : (
            <span className="text-red-500 text-xs block font-light">
              {error?.message || ""}
            </span>
          ))}
    </div>
  );
};

export default Input;